<template>
  <div ref="el" class="w-100 h-100" :class="{ 'crosshair-btn-on': crosshairOn }" @contextmenu.prevent="emitContextMenu">
  </div>
</template>
<script>
import { useCandlesChartEngine } from "../utils/CandlesChartEngineCore";
export default {
  name: "CandlesChartEngine",
  emits: ["ready", "contextmenu", "crosshair-change", "table-data", "table-columns"],
  props: {
    tf: { type: Object, default: null },
    chartType: { type: Object, default: null },
    renkoBrick: { type: Number, default: 200 },
    crosshairOn: { type: Boolean, default: false },
  },
  data() {
    return {
      el: null,
      engine: null,
      lastCrosshairOn: null,
      lastTfKey: null,
      lastChartTypeKey: null,
    };
  },
  mounted() {
    this.el = this.$refs.el;
    this.engine = useCandlesChartEngine({
      getEl: () => this.$refs.el,
      getProps: () => ({
        tf: this.tf,
        chartType: this.chartType,
        renkoBrick: this.renkoBrick,
        crosshairOn: this.crosshairOn,
      }),
      emit: (name, payload) => this.$emit(name, payload),
      nextTick: (fn) => this.$nextTick(fn),
    });
    this.engine.mount();
    this.lastCrosshairOn = !!this.crosshairOn;
    this.lastTfKey = this.tf?.key ?? "1D";
    this.lastChartTypeKey = this.chartType?.key ?? "";
  },
  updated() {
    if (!this.engine) return;
    const nowCrosshair = !!this.crosshairOn;
    if (nowCrosshair !== this.lastCrosshairOn) {
      this.lastCrosshairOn = nowCrosshair;
      this.engine.onCrosshairPropChange(nowCrosshair);
    }
    const nowTfKey = this.tf?.key ?? "1D";
    if (nowTfKey !== this.lastTfKey) {
      this.lastTfKey = nowTfKey;
      this.engine.onTfChange(nowTfKey);
    }
    const nowChartTypeKey = this.chartType?.key ?? "";
    if (nowChartTypeKey !== this.lastChartTypeKey) {
      this.lastChartTypeKey = nowChartTypeKey;
      this.engine.onChartTypeChange(nowChartTypeKey);
    }
  },
  beforeUnmount() {
    this.engine?.unmount();
  },
  methods: {
    emitContextMenu(e) {
      this.$emit("contextmenu", { clientX: e.clientX, clientY: e.clientY });
    },
    setSymbol(ticker) {
      return this.engine?.setSymbol(ticker);
    },
    setActiveStudies(studies) {
      return this.engine?.setActiveStudies(studies);
    },
    fitContent() {
      return this.engine?.fitContent();
    },
    getBars() {
      return this.engine?.getBars();
    },
    getMainPaneId() {
      return this.engine?.getMainPaneId();
    },
    getRootEl() {
      return this.$refs.el;
    },
  },
};
</script>
